import Instafeed from 'instafeed.js';

function getFeed(url, widgetIndex) {
  if (url) {
    $.ajax({
      type: 'get',
      dataType: 'json',
      url: url,
      success: function (response) {
        const feed = new Instafeed({
          template:
            '<a href="{{link}}">' +
            '<figure>' +
            '<picture>' +
            '<source srcset="{{image}}" media="(min-width: 768px)" />' +
            '<source srcset="{{image}}" media="(min-width: 1024px)" />' +
            '<img title="{{short_caption}}" alt="{{short_caption}}" src="{{image}}" />' +
            '</picture>' +
            '</figure>' +
            '</a>',
          accessToken: response.Token,
          target: 'instafeed' + (widgetIndex ? '-' + widgetIndex : ''),
          limit: 8,
          transform: function (item) {
            // The caption gets cropped to the first 5 words for a preview
            const caption = item.caption || '';
            const shortCaption = caption.split(' ').slice(0, 5).join(' ').concat('...');
            item.short_caption = shortCaption;
            return item;
          }
        });

        feed.run();
      }
    });
  }
}

const feed = {
  get: ($instagramFeeds) => {
    // For each Instagram feed element configured in Page Designer, get the URL and widget index
    $instagramFeeds.each(function (index, elem) {
      const $this = $(elem);
      const url = $this.data('url');
      const widgetIndex = $this.data('widget-index');

      getFeed(url, widgetIndex);
    });
  }
};

export default feed;
